import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Globals } from '../../../globals';

@Component({
  selector: 'left-nav',
  templateUrl: './left-nav.component.html',
  standalone: false,
})
export class LeftNavComponent implements OnChanges {
  @Input() meta;
  @Input() isSecNav;
  @Input() isSidebarPresent;
  @Input() renderer: 'legacy' | 'designtoken' = 'legacy';
  @Output() sidebarEvent = new EventEmitter<any>();
  @Input() sidebarShow = false;
  navReady = false;
  isInitialNavLoad = true;
  constructor(public globals: Globals) {}
  
  ngOnChanges(changes: SimpleChanges) {
    const navImplementationChanged =
      (changes.renderer && !changes.renderer.firstChange) ||
      (changes.isSidebarPresent && !changes.isSidebarPresent.firstChange);

    if (navImplementationChanged) {
      this.navReady = false;
      this.isInitialNavLoad = true;
    }
  }

  sidebarEventHandler() {
    this.sidebarShow = !this.sidebarShow;
    this.sidebarEvent.emit(this.sidebarShow);
  }

  onNavReady(value: boolean) {
    this.navReady = value && this.hasNavSource();
    if (!this.navReady) {
      return;
    }

    this.isInitialNavLoad = false;
  }

  hasNavSource(): boolean {
    return !!(this.meta?.['vertical-nav'] || this.meta?.['sidebar-menu']);
  }

  isDocPageNav(): boolean {
    if (!this.meta) {
      return false;
    }

    if (this.renderer === 'designtoken') {
      return (
        (this.meta.template === 'app-api-doc' || this.meta.template === 'app-product-landing') &&
        (this.meta['sec-nav'] || this.meta['secondary-nav'])
      );
    }

    return (
      (this.meta.template === 'doc-page' ||
        this.meta.template === 'app-api-doc' ||
        this.meta.template === 'product-landing' ||
        this.meta.template === 'prod-doc-page') &&
      (this.meta['sec-nav'] || this.meta['secondary-nav'])
    );
  }

}
